import { DataLandingContext } from "context/DataLanding.context";
import React from "react";

export const useDataLanding= () => React.useContext(DataLandingContext)  